import { device } from '../constants/actionTypes';

/**
 * @issue      About iPadOS: https://developer.apple.com/forums/thread/119186
 * @note       2020/3/20 iPadOS 13.4 之後若接上外部 pointer 裝置，可支援 CSS hover，因此不能以能否 hover 做判斷, ref: https://blog.user.today/ipados-mouse-event-test/
 */
export function checkIpadOs() {  
  const checkIsIpadOs = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return false;

    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('macintosh') > -1 && 'ontouchend' in document) {
      return true;
    } else {
      return false;
    }
  }

  return {
    type: device.CHECK_IPAD_OS,
    payload: checkIsIpadOs(),
  };
}